import { createBigDecimal } from '@0xtorch/big-decimal'
import type { Transfer } from '@0xtorch/core'
import type { z } from 'zod'
import type { LowerHex, TransactionDecoded } from '../../../../types'
import { createEvmAddressId } from '../../../../utils'
import { checkTransferIsMatchErc721Pattern } from './erc721Pattern'
import type { erc721TransferGeneratorSchema } from './schema'

export const generateTransfersByErc721Transfer = ({
  schema,
  transaction,
  relatedAddresses,
}: {
  readonly schema: z.infer<typeof erc721TransferGeneratorSchema>
  readonly transaction: TransactionDecoded
  readonly relatedAddresses: Set<LowerHex>
}): readonly Transfer[] => {
  const transfers: Transfer[] = []
  let currentIndex = -1
  for (const transfer of transaction.erc721Transfers) {
    const matched = checkTransferIsMatchErc721Pattern({
      transfer,
      schema,
      transaction,
      relatedAddresses,
    })
    if (matched) {
      currentIndex += 1
      if (schema.index === undefined || currentIndex === schema.index) {
        transfers.push({
          direction: schema.direction,
          from: createEvmAddressId({
            chainId: transaction.chainId,
            address: transfer.from,
          }),
          to: createEvmAddressId({
            chainId: transaction.chainId,
            address: transfer.to,
          }),
          asset: transfer.token,
          amount: createBigDecimal(1n),
        })
      }
      if (currentIndex === schema.index) {
        return transfers
      }
    }
  }
  if (schema.index === undefined) {
    return transfers
  }
  throw new Error('Matched ERC721 transfer is not found')
}
